import styled from "styled-components";

export const DashboardOperationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  height: calc(100vh - 130px);
  overflow-y: auto;
  width: 100%;
`;
export const CardOperationsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
`;

export const RecentUsersContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  // min-height: 500px;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    gap: 22px;
  }
`;
